import { WidgetHelper } from '@/helpers/Widget'
import BasketWidget from '@/modules/BasketWidget/components/BasketWidget'

WidgetHelper.registerOnce(BasketWidget, '#basketWidget')
// WidgetHelper.registerContinuously(BasketWidget, '#basketWidget')
